import api from "../../services/api";

export const getArticles = async () => {
  try {
    const response = await api.get('/posts');
    console.log("Dados da API: ", response.data);
    return response.data;
    
  } catch (error) {
    console.error("Erro aou buscar artigos:", error);
    throw error;
  }  
}

export const getArticlesAdmin = async (page: number, limit: number, token: string) => {
  try {
    const response = await api.get(`/posts/admin?page=${page}&limit=${limit}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;

  } catch (error) {
    console.log("Erro ao buscar artigos", error);
    return { data: [], total: 0, page: 1, lastPage: 1, hasMore: false };
  }
}

export const getTreinamentos = async (token: string) => {

  try {
    const response = await api.get('/treinamento', {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;

  } catch(error) {
    console.log("Erro ao buscar treinamentos", error);
  }
}

export const getTreinamentosDetalhe = async (id: number, token: string) => {
  try {
    const response = await api.get(`/treinamento/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });

    return response.data;
  } catch(error) {
    console.log("Error ao buscar aulas.", error);
  }
}